module.exports = __webpack_public_path__ + "static/img/kx1-4.4d8348b.png";


//////////////////
// WEBPACK FOOTER
// ./static/workoff/excelimg/layout/kx1-4.png
// module id = 754
// module chunks = 0